module.exports = __webpack_public_path__ + "static/media/up-green-icon.5843931f.png";